import React from 'react';
export function Garantia() {
  return <section className="py-[60px] px-5 bg-light" data-id="element-74">
      <div className="max-w-[760px] mx-auto" data-id="element-75">
        <div className="bg-card border border-cardBorder border-t-[3px] border-t-gold rounded-2xl py-10 px-8 text-center max-w-[600px] mx-auto" data-id="element-76">
          <div className="text-5xl mb-4" data-id="element-77">🛡️</div>
          <p className="text-[22px] font-black text-white mb-4" data-id="element-78">
            GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </p>
          <p className="text-[15px] text-text-muted leading-relaxed mb-4" data-id="element-79">
            Abrís los tomos. Los aplicás en tu cuenta. Si en 7 días no es lo que
            esperabas: devolución del 100%. Sin formularios. Sin drama. Sin
            vuelta.
          </p>
          <p className="text-[13px] text-gold font-bold tracking-[1px]" data-id="element-80">
            TASA DE DEVOLUCIONES: MENOS DEL 1%.
          </p>
        </div>
      </div>
    </section>;
}